import React from 'react'
import { formatCurrency } from './formatters'

export interface TopOverdueInvoicesProps {
	invoices: Record<string, unknown>[]
}

export const TopOverdueInvoices: React.FC<TopOverdueInvoicesProps> = ({ invoices }) => {
	const top = invoices.slice(0, 5)
	if (top.length === 0) return null

	return (
		<div className="bg-white rounded-xl border border-slate-200 shadow-md p-4">
			<div className="flex items-center justify-between mb-3">
				<h3 className="text-[12px] font-bold text-slate-800">Top overdue invoices</h3>
				<span className="text-[10px] text-slate-500 bg-slate-100 px-2 py-0.5 rounded">
					Top {top.length}
				</span>
			</div>
			<div className="space-y-2 max-h-80 overflow-y-auto">
				{top.map((inv, i) => {
					const risk = String(inv.collection_risk || '')
					const riskCls =
						risk.includes('Critical')
							? 'bg-rose-50 text-rose-800 border-rose-200'
							: risk.includes('Medium')
								? 'bg-amber-50 text-amber-900 border-amber-200'
								: 'bg-emerald-50 text-emerald-800 border-emerald-200'
					return (
						<div
							key={`${inv.invoice_id}-${i}`}
							className="rounded-lg p-3 border border-slate-100 bg-slate-50/80"
						>
							<div className="flex justify-between gap-2">
								<div className="min-w-0">
									<p className="font-semibold text-slate-900 text-[13px]">
										Invoice #{String(inv.invoice_id)}
									</p>
									<p className="text-[11px] text-slate-600 truncate">{String(inv.customer)}</p>
									<div className="flex flex-wrap gap-1 mt-1">
										<span className={`text-[10px] px-2 py-0.5 rounded border ${riskCls}`}>
											{risk || '—'}
										</span>
										<span className="text-[10px] text-slate-500 bg-white border border-slate-200 px-2 py-0.5 rounded">
											{String(inv.aging_bucket || '')}
										</span>
									</div>
									<p className="text-[10px] text-slate-500 mt-1">Due: {String(inv.due_date)}</p>
								</div>
								<div className="text-right shrink-0">
									<p className="text-[13px] font-bold text-rose-700 tabular-nums">
										{formatCurrency(Number(inv.amount))}
									</p>
									<p className="text-[10px] text-slate-500">
										{Number(inv.days_overdue)} days overdue
									</p>
								</div>
							</div>
						</div>
					)
				})}
			</div>
		</div>
	)
}
